import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  icon, 
  iconColor = 'var(--color-primary)',
  trend = null,
  trendDirection = 'up',
  onClick = null
}) => {
  const isClickable = onClick !== null;

  const handleClick = () => {
    if (isClickable) {
      onClick();
    }
  };

  const handleKeyDown = (e) => {
    if (isClickable && (e?.key === 'Enter' || e?.key === ' ')) {
      e?.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`
        bg-card rounded-xl p-4 md:p-6 border border-border shadow-elevation-1
        transition-smooth
        ${isClickable ? 'cursor-pointer hover:shadow-elevation-2 hover:-translate-y-1' : ''}
      `}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={isClickable ? 'button' : 'article'}
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground mb-1 md:mb-2">
            {title}
          </p>
          <p className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground truncate">
            {value}
          </p>
        </div>
        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center ml-3 md:ml-4">
          <Icon name={icon} size={20} color={iconColor} />
        </div>
      </div>
      
      {trend && (
        <div className="flex items-center space-x-2">
          <Icon 
            name={trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            color={trendDirection === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
          />
          <span className={`text-xs md:text-sm font-medium ${
            trendDirection === 'up' ? 'text-success' : 'text-error'
          }`}>
            {trend}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;